import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { Button, Toast, ToastContainer } from '@salesforce/design-system-react';

import './ProfileUpload.scss';
import * as Util from '../../../common/utilities';

class ProfileUpload extends Component {
  constructor(props) {
    super(props);
    this.inputFileRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(prevProps, this.props, 'profileUpload.isSaving') &&
      this.props.profileUpload.isSaving === false
    ) {
      if (!this.props.profileUpload.error) {
        this.props.actions.openToast('profileUploadSuccess');
      }
    }
  }

  handleFileSelect(event) {
    const file =
      event.target.files && event.target.files.length && event.target.files[0];
    if (file) {
      const payload = new FormData();
      payload.append('profile', file, file.name);
      this.props.actions.uploadProfile(payload, {
        cToken: this.props.session.cToken
      });
    }
  }

  toast() {
    const { formatMessage } = this.props.intl;
    if (this.props.toast.profileUploadSuccess) {
      let toast = 'profileUploadSuccess';
      const heading = formatMessage({
        id: `components.ecs.setup.toast.profileUploadSuccess.heading`
      });
      const details = formatMessage({
        id: `components.ecs.setup.toast.profileUploadSuccess.details`
      });
      return (
        <Toast
          labels={{ heading, details }}
          variant={'success'}
          duration={5000}
          onRequestClose={() => this.props.actions.closeToast(toast)}
        />
      );
    }
    return null;
  }

  render() {
    const { formatMessage } = this.props.intl;

    let uploadText = formatMessage({
      id: 'components.ecs.setupProfiles.uploadProfile.description'
    });
    let uploadLabel = formatMessage({
      id: 'components.ecs.setupProfiles.uploadProfile.button'
    });
    let downloadText = formatMessage({
      id: 'components.ecs.setupProfiles.downloadSchema'
    });

    return (
      <div>
        <div>
          <input
            type="file"
            id="open-file-input"
            ref={this.inputFileRef}
            style={{ display: 'none' }}
            onChange={this.handleFileSelect.bind(this)}
            accept="application/json"
          />
          <Button
            className="link-span profile-upload-button"
            assistiveText={{ label: 'Upload' }}
            iconCategory="utility"
            iconName="upload"
            label={uploadLabel}
            onClick={() => this.inputFileRef.current.click()}
          />
          {uploadText}
        </div>
        <a download href="/profile_upload_schema.json">
          {downloadText}
        </a>
        <ToastContainer>{this.toast()}</ToastContainer>
      </div>
    );
  }
}

ProfileUpload.propTypes = {
  actions: PropTypes.object,
  profileUpload: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  session: PropTypes.object
};

export default injectIntl(ProfileUpload);
